import React from "react";
import TopProgress from "./TopProgress";
import styled from "styled-components";
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

import Telefon from "../../../assets/img/telefon.svg";
import Hvezdy from "../../../assets/img/hodnoceniKremace.svg";
import Check from "../../../assets/img/check.svg";
import GoogleLogo from "../../../assets/img/google.svg";
import FirmyLogo from "../../../assets/img/firmyLogo.png";

const LayoutDotaznikInner = styled.section`
  background: #FBFBFA;
  min-height: calc(100vh - 65px);

  .content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: calc(100% - 100px);
    max-width: 1150px;
    margin: 0 auto;
    margin-top: 70px;
    padding-bottom: 1px;

    @media (max-width: 1000px) {
      display: block;
    }

    @media (max-width: 900px) {
      width: calc(100% - 50px);
      margin-top: 40px;
    }

    .left {
      width: calc(100% - 480px);
      max-width: 800px;

      @media (max-width: 1000px) {
        width: calc(100%);
        max-width: none;
      }
      
      .cta {
        font-family: Visuelt-Medium;
        font-size: 18px;
        color: #FFFFFF;
        text-align: center;
        width: calc(100%);
        max-width: 290px;
        margin: 0;
        display: block;
        background: #1D3A5B;
        border-radius: 3px;
        padding: 19px 0;
        text-decoration: none;

        @media (max-width: 900px) {
          padding: 18px 0;
          max-width: 260px;
        }

        &:hover {
          background: #081C33;
          cursor: pointer;
        }
      }

      h1 {
        font-family: Ivar;
        font-size: 32px;
        color: #000000;
        line-height: 45px;

        @media (max-width: 900px) {
          font-size: 27px;
          line-height: 39px;
        }
      }

      p {
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #4D4D4D;
        line-height: 25px;
        margin-top: 35px;
        margin-bottom: 50px;

        @media (max-width: 900px) {
          margin-top: 25px;
          margin-bottom: 35px;
        }
      }

      .vyberPohrbu {
        button {
          display: inline-block;
        }
      }

      button {
        cursor: pointer;
        display: block;
        font-family: Visuelt-Medium;
        font-size: 24px;
        color: #000000;
        text-align: center;
        max-width: 320px;
        width: 100%;
        padding: 35px 0;
        background: #FFFFFF;
        border: 1px solid #dedede;
        box-shadow: 0 5px 10px 0 rgba(0,0,0,0.11);
        border-radius: 5px;
        margin-bottom: 30px;

        @media (max-width: 900px) {
          margin-bottom: 25px;
        }

        &:hover {
          cursor: pointer;
          background: #f9f9f9;
        }
      }

      .zpet {
        font-family: Visuelt-Bold;
        font-size: 16px;
        color: #4D4D4D;
        margin-top: 50px;
        display: block;
        text-decoration: none;
        padding-bottom: 100px;
        width: 100%;

        @media (max-width: 900px) {
          margin-top: 35px;
        }

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .siroky {
      max-width: 1150px;
      width: calc(100%);

      .vyberPohrbu {
        margin-top: 35px;
        display: grid; 
        grid-template-columns: 1fr 1fr 1fr;
        gap: 35px;
        max-width: 1030px;

        @media (max-width: 1000px) {
          grid-template-columns: 1fr 1fr; 
          max-width: 680px;
        }

        @media (max-width: 700px) {
          grid-template-columns: 1fr;
        }

        @media (max-width: 400px) {
          gap: 25px;
        }

        button {
          margin-right: 35px;
          height: fit-content;
          cursor: pointer;
        }

        .obrazkovyButton {
          vertical-align: top;
          padding-top: 0;
          overflow: hidden;
          text-align: left;
          margin-right: 35px;
          margin-bottom: 0;
          padding-bottom: 25px;
          height: fit-content;
          position: relative;

          @media (max-width: 400px) {
            padding-bottom: 20px;
          }

          .obrazek {
            height: 200px !important;
            width: 100% !important;
          }

          h2 {
            font-family: Visuelt-Medium;
            font-size: 24px;
            color: #000000;
            display: block;
            margin: 0 auto;
            width: calc(100% - 50px);
            margin-top: 25px;

            @media (max-width: 400px) {
              margin-top: 20px;
              width: calc(100% - 40px);
            }
          }

          p {
            font-family: Visuelt-Regular;
            font-size: 16px;
            color: #4D4D4D;
            line-height: 25px;
            display: block;
            margin: 15px auto;
            width: calc(100% - 50px);

            @media (max-width: 400px) {
              width: calc(100% - 40px);
            }
          }

          span {
            font-family: Visuelt-Bold;
            font-size: 15px;
            color: #4D4D4D;
            line-height: 25px;
            display: block;
            margin: 0 auto;
            width: calc(100% - 50px);

            @media (max-width: 400px) {
              width: calc(100% - 40px);
            }
          }

          .zahrnuto {
            color: #48B15C;
          }
        }
      }

      .vyberBlizkeho {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        max-width: 1150px;
        gap: 25px;

        @media (max-width: 1000px) {
          grid-template-columns: 1fr 1fr 1fr;
        }

        @media (max-width: 760px) {
          grid-template-columns: 1fr 1fr;
          gap: 15px;
        }

        button {
          margin-bottom: 0;

          @media (max-width: 760px) {
            width: calc((100vw - 15px - 50px)/2);
            margin: 0 auto;
          }

          @media (max-width: 500px) {
            font-size: 20px;
          }
        }
      }
    }

    .right {
      .contactCard {
        background: #FFFFFF;
        padding: 30px;
        width: 370px;

        background: #FFFFFF;
        box-shadow: 0 9px 20px 0 rgba(0,0,0,0.07);
        border-radius: 5px;

        @media (max-width: 1100px) {
          width: 400px;
          padding: 25px;
        }

        @media (max-width: 1000px) {
          margin-bottom: 100px;
          margin-top: -50px;
        }

        @media (max-width: 900px) {
          max-width: 400px;
          padding: 25px;
          width: calc(100% - 50px - 2px);
        }

        h2 {
          font-family: Visuelt-Medium;
          font-size: 22px;
          color: #000000;
          margin-bottom: 30px;

          @media (max-width: 900px) {
            font-size: 20px;
          }
        }

        .support {
          display: flex;
          align-items: center;

          @media (max-width: 900px) {
            display: block;
          }

          .rightSupp {
            margin-left: 25px;

            @media (max-width: 900px) {
              margin-left: 0;
              margin-top: 15px;
            }

            .phone {
              display: flex;
              align-items: center;

              img {
                height: 20px;
                margin-right: 12px;
                margin-top: -1px;
              }

              span {
                font-family: Visuelt-Medium;
                font-size: 24px;
                color: #000000;
              }
            }

            .kDispozici {
              width: fit-content;
              margin: 0 auto;
              margin-top: 10px;

              @media (max-width: 900px) {
                margin-left: 0;
              }

              .greenDot {
                background: #49B25D;
                height: 10px;
                width: 10px;
                border-radius: 100%;
                animation: pulse 2s infinite;
                display: inline-block;
                vertical-align: middle;
              }

              span {
                font-family: Visuelt-Medium;
                font-size: 16px;
                color: #48B15C;
                line-height: 24px;
                vertical-align: middle;
                margin-left: 10px;
              }

              @keyframes pulse {
                0% {
                  opacity: 1;
                }

                50% {
                  opacity: 0.25;
                }

                100% {
                  opacity: 1;
                }
              }
            }
          }
        }

        hr {
          border: 0;
          margin: 30px 0;
          border-top: 1px solid #D8D8D8;
        }

        .sites {
          .site {
            display: flex;
            align-items: center;
            margin-top: 20px;

            .logo {
              max-width: 119px;
              max-height: 31px;
              margin-right: 15px;
            }
          }
        }

        .overenaFirma {
          display: flex;

          @media (max-width: 900px) {
            display: block;
          }

          div {  
            img {
              height: 14px;
              margin-left: 12px;
              margin-top: -2px;
            }

            span {
              font-family: Visuelt-Medium;
              font-size: 14px;
              color: #000000;
            }

            .scrollLink {
              font-family: Visuelt-Medium;
              font-size: 14px;
              color: #000000;
              text-decoration: underline;
              cursor: pointer;
              margin: 0 !important;
            }

            &:first-child {
              border-right: 2px solid #D2D2D2;
              padding-right: 15px;
              margin-right: 15px;

              @media (max-width: 900px) {
                border-right: none;
                margin-bottom: 15px;
              }
            
              img {
                height: 16px;
                margin: 0;
                margin-right: 10px;
                margin-top: -1px;

                @media (max-width: 490px) {
                  height: 12px;
                  margin-right: 7px;
                }
              }
            }
          }
        }
      }
    }
  }
`;

const DotaznikLayout = ({ phase, progress, children, isSupp }) => {
  return (
    <LayoutDotaznikInner>
      <TopProgress phase={phase} progress={progress} />

    

      <section className="content">
        <div className={"left " + (!isSupp ? "siroky" : null)}>
          {children}
        </div>

        {isSupp &&
          <div className="right">
            <div className="contactCard">
              <h2>Naši specialisté vám pomohou se ve všem zorientovat</h2>

              <div className="support">
                <StaticQuery
                  query={graphql`
                    query {
                      file(relativePath: { eq: "podpora.png" }) {
                        childImageSharp {
                          fixed(width: 150, quality: 100) {
                            ...GatsbyImageSharpFixed_noBase64
                          }
                        }
                      }
                    }
                  `}
                  render={data => (
                    <Img className="obrazek" alt="Naše podpora" fixed={data.file.childImageSharp.fixed} />
                  )}
                />
                <div className="rightSupp">
                  <a href="tel:315558136" className="phone">
                    <img src={Telefon} alt="" />
                    <span>315 558 136</span>
                  </a>
                  <div className="kDispozici">
                    <div className="greenDot"></div>
                    <span>Jsme k dispozici 24/7</span>
                  </div>
                </div>
              </div>

              <hr />

              <div className="overeno">
                <div className="overenaFirma">
                  <div>
                    <img alt="" src={Check} />
                    <span>Ověřeno zákazníky</span>
                  </div>
                  <div>
                    <span>Hodnocení 4,9/5</span>
                  </div>
                </div>
                <div className="sites">
                  <div className="site">
                    <img className="logo" src={GoogleLogo} alt="Google Logo" />
                    <img className="stars" src={Hvezdy} alt="" />
                  </div>
                  <div className="site">
                    <img className="logo" src={FirmyLogo} alt="Firmy.cz Logo" />
                    <img className="stars" src={Hvezdy} alt="" />
                  </div>
                </div>
              </div>


            </div>
          </div>
        }
      </section>
      
    </LayoutDotaznikInner>
  )
}



export default DotaznikLayout;